import { useState } from "react";
import { PrivateUser } from "../../CRUD/CampSites/types";
import PrivateUserDetail from "./PrivateUserDetail";


interface PrivateUserListProps {
    privateUsers: PrivateUser[];
    onEdit: (privateUser: PrivateUser) => void;
    onDelete: (id: number) => void;
    onView: (privateUser: PrivateUser) => void;
};

const PrivateUserList: React.FC<PrivateUserListProps> = ({ privateUsers, onEdit, onDelete, onView }) => {
    const [selectedPrivateUser, setSelectedPrivateUser] = useState<PrivateUser | null>(null);

    return (
        <>
            <div className='private-user-list'>
                {selectedPrivateUser ? (
                    <PrivateUserDetail
                        privateUser={selectedPrivateUser}
                        onClose={() => setSelectedPrivateUser(null)}
                        onEdit={onEdit}
                    />
                ) : (
                    <section className='private-user-list-section'>
                        <div className='private-user-list'>
                            <div className="list-header">
                                <span>Name</span>
                                <span>Email</span>
                                <span>Actions</span>
                            </div>
                            <ul className="list-group">
                                {privateUsers.map(user => (
                                    <li key={user.id} className="list-group-item">
                                        <span className="private-user-field">{user.name}</span>
                                        <span className="private-user-field">{user.email}</span>
                                        <div className="private-user-actions">
                                            <div className="action-button">
                                                <button className="btn btn-sm btn-outline-info me-2" onClick={() => onView(user)}>
                                                    <i className="fas fa-eye"></i> View
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </section>
                )}
            </div>
        </>
    );
};

export default PrivateUserList;
    